<template lang="html">
<content-div>
  <step-bar :step="step" title="주행거리 입력 및 차량 계기판 촬영"></step-bar>

  <div class="popWrap">
    <div class="popCon">
      <div class="contArea">
        <div class="conTit1 mgb mgt2">현재 차량 주행거리를 입력해주세요.</div>
				<div class="phInput">
					<input type="text" v-model="kmStr"><span>km</span>
				</div>
        <p class="txtInfo mgt1">입력하신 주행거리와 실제 주행거리가 다를 시,<br>서비스 제공에 제한이 있을 수 있습니다.</p>
      </div>
    </div>

    <button-apply before="/subscApply/vehicleInsp" @submit="submit"></button-apply>

    <popup-alert v-if="activate" title="알림" @close="activate=false">
      <popup-msg :type="popupMsg"></popup-msg>
    </popup-alert>

    <popup-picture-ex 
      v-if="panelActivate"  
      :type="Const.SUBSC_ATT.PANEL" 
      @close="panelClose">
    </popup-picture-ex>

  </div>
</content-div>
</template>


<script>
import Const from '../../../helpers/Const';
import ButtonApply from "@/components/Button/ButtonSubscApply.vue";
import PopupAlert from '@/components/Popup/PopupAlert.vue';
import PopupMsg from "@/components/Popup/PopupMsgTemplate";
import PopupPictureEx from '@/components/Popup/PopupPictureEx.vue';
import StepBar from '@/components/StepBar.vue';

  export default {
    beforeRouteEnter(to, from, next) {
      // if (
      //   from.name != 'SubscApplyVehicleInsp' &&  // 구독 신청 검사표 촬영
      //   from.name != 'SubscApplyReq'             // 구독 신청 전송
      // ) {
      //   alert('잘못된 접근경로 입니다.');
      //   this.$store.commit("unsetTerms");
      //   next('/')
      // } else {
        next();
      // }
    },

    components: {
      ButtonApply,
      PopupAlert,
      PopupMsg,
      PopupPictureEx,
      StepBar,
    },

    created() {
      this.step = Number(this.$route.query.step);
      window.scroll(0, 0);
      this.kmStr = this.km;
    },

    data() {
      return {
        step: 0,
        Const,
        panelActivate: false,
        activate: false,
        km: this.$store.state.vehicle.km,
        kmStr: '',
        popupMsg: '',
      };
    },

    methods: {
      panelClose(bool){
        this.panelActivate = false;
        if(bool) this.setVehiclePanel();
        // if(bool) this.$router.push("/subscApply/req");
      },

      getKmStrToNum(val) {
        let km = val;
        km = km.replace(/[^0-9]/g, '');   // 입력값이 숫자가 아니면 공백
        km = km.replace(/,/g, '');        // , 공백처리
        return km;
      },

      setVehiclePanel() {
        this.$store.commit("setVehiclePanel", {km: this.km});
        this.callTakePictureAndUploadApi(1);
      },

      // app api response
      callbackRunTakePicture(value) {
        this.callbackRunTakePictureSubmit(value);
      },

      submit() {
        if (!this.km) {
          this.popupMsg = 'NEED_INPUT_KM';
          this.activate = true;
        } else if ((this.$store.state.pkg.is_assurance) && this.km > 180000) {
          this.popupMsg = 'KM_LIMIT_WARNING';
          this.activate = true;
        } else {
          this.panelActivate = true;
          // this.setVehiclePanel();
        }
      },
    },

    watch: {
      kmStr(val) {
        let km = this.getKmStrToNum(val);
        if (km.length > 1 && km[0] == 0) {
          km = km[1];
        }
        this.km = km;  // 숫자처리
        this.kmStr = km.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },
    },
  };
</script>